<template>
    <div
        id="app"
        @dragenter="onDragEnter($event)"
    >
        <the-header :title="$route.meta.title"/>
        <o-background />
        <o-notifications name="default"/>
        <router-view/>
        <the-footer />
    </div>
</template>

<script>
import TheHeader from '@/components/TheHeader'
import TheFooter from '@/components/TheFooter'
import OBackground from '@/components/OBackground'
export default {
    components: {
        TheHeader,
        OBackground,
        TheFooter
    },
    metaInfo: {
        title: 'TAKE A FRUIT B2B',
        titleTemplate: '%s | TAKE A FRUIT B2B',
        htmlAttrs: {
            lang: 'pl'
        }
    },
    watch: {
        $route(to, from) {
            if(this.$router.currentRoute.meta.offerMode) {
                if((to.name === 'offer-checkout' || to.name === 'offer-delivery-address') &&
                    from.name !== 'offer-cart' && from.name !== 'offer-delivery-address' &&
                    from.name !== 'offer-cart-mobile-week' &&
                    from.name !== 'offer-cart-mobile-summary'
                ) {
                    this.$router.push({ name: 'offer-cart', params: to.params.slug })
                } else {
                    // this.$store.dispatch('fetchAppData')
                }
            } else if(!this.$router.currentRoute.path.includes('/dashboard')) {
                if(from.name === null) {
                    this.$store.dispatch('fetchAppData')
                }
            }
        }
    },
    methods: {
        onDragEnter($event) {
            if(!this.$router.currentRoute.meta.offerMode) {
                const targetEl = $event.composedPath().find(item => item.className === 'm-week__day' || item.className === 'm-week__day m-week__day--alert')
                if(targetEl !== undefined) {
                    const dayId = +targetEl.dataset.dayId
                    if(this.$store.getters.dragPackageDayInWeek !== dayId) {
                        this.$store.dispatch('setDragSamplePackageDayId', dayId)
                    }
                } else {
                    this.$store.dispatch('setDragSamplePackageDayId', false)
                }
            } else {
                const targetEl = $event.composedPath().find(item => item.className === 'm-week__day' || item.className === 'm-week__day m-week__day--alert')
                const targetRelatedProducts = $event.composedPath().find(item => item.className === 'm-related')
                if(targetEl !== undefined) {
                    const dayId = +targetEl.dataset.dayId
                    if(this.$store.getters.dragPackageDayInWeek !== dayId && this.$store.getters.dragProductId !== null) {
                        this.$store.dispatch('setDragSamplePackageDayId', dayId)
                    }
                } else if(targetRelatedProducts !== undefined) {
                    this.$store.dispatch('setDragSamplePackageDayId', 'relatedProducts')
                } else {
                    this.$store.dispatch('setDragSamplePackageDayId', false)
                }
            }
        },
        handleMouse(getCurrentPos) {
            const mouseX = getCurrentPos.clientX
            const mouseY = getCurrentPos.clientY
            document.body.style.setProperty('--mouseX', `${mouseX}px`)
            document.body.style.setProperty('--mouseY', `${mouseY}px`)
        }
    },
    mounted() {
        window.addEventListener('dragend', () => {
            this.$store.dispatch('dragReset')
        })
        window.addEventListener('mousemove', this.handleMouse)
    },
    destroy() {
        window.removeEventListener('dragend')
        window.removeEventListener('mousemove', this.handleMouse)
    }
}

</script>

<style lang="sass">
#id
    background-image: "~/assets/2.png"
</style>
